import React, { useState, useEffect } from 'react'

// bootstrap
import {
    Container,
    Image,
    Button,
    Spinner,
} from 'react-bootstrap'

// auth styles
import '../styles/auth-styles.scss'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// react router
import { Link } from 'react-router-dom';

// logo
// import appLogo from 'assets/images/logo.png'
import appLogo from 'assets/images/logo.svg'

// redux
import { connect } from 'react-redux'

// react toastify
import { toast, Slide } from 'react-toastify';

// icons : feather
import FeatherIcon from 'feather-icons-react';

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon'

// API
import { validateResetPassword, cancelValidateResetPasswordApi, resetPassword } from 'utlis/Apis/Customers_API'

// login check
import WithLoginCheck from 'routes/WithLoginCheck'

function ResetPassword(props) {
    // props
    const {
        authState,
        match,

        globalLoading,
        setGlobalLoading,
    } = props

    // states
    const [buttonDisable, setButtonDisable] = useState(false)
    const [buttonLoading, setButtonLoading] = useState(false)

    const [showPassword, setShowPassword] = useState(false)

    const [isRequestValid, setIsRequestValid] = useState(false)

    const [userIdFromUrl, setUserIdFromUrl] = useState("")
    const [userTokenFromUrl, setUserTokenFromUrl] = useState("")

    // checking if reset password details are valid
    useEffect(() => {
        if (match?.params?.userId && match?.params?.userToken) {

            setUserIdFromUrl(match.params.userId) // setting details
            setUserTokenFromUrl(match.params.userToken)  // setting details

            // global loading
            setGlobalLoading(true)

            const dataToValidate = {
                userId: match.params.userId,
                userToken: match.params.userToken
            }

            const headers = {
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // validating user details
            validateResetPassword(headers, dataToValidate).then(res => {
                // global loading
                setGlobalLoading(false)

                const resData = res.data

                if (resData?.success) {  // if link is valid
                    setIsRequestValid(true)
                }

                if (resData?.error) {  // if link is inValid
                    setIsRequestValid(false)

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.info(resData?.message ?? "Unauthorized Access", {
                        autoClose: 2500,
                        onClose: () => { },
                    });
                }

            }).catch(err => {
                console.log("errr ", err);

                // global loading
                setGlobalLoading(false)
            })

            return () => {
                cancelValidateResetPasswordApi && cancelValidateResetPasswordApi()
            }
        }
    }, [match.params.userId, match.params.userToken])

    // initial values
    const initialFormValues = {
        password: "",
    }

    // handle validations
    const formValidationSchema = Yup.object({
        password: Yup.string()
            .required('This field is required')
            .min(8, "The password must be at least 8 characters long")
            .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, "Pasword must contain at least one uppercase letter, one lowercase letter, one number and one special character")
    })

    // handle submmision
    const onFormSubmit = values => {
        if (values) {
            // button loading
            setButtonLoading(true)
            setButtonDisable(true)

            const requiredData = {
                password: values.password,
                userId: userIdFromUrl,
                userToken: userTokenFromUrl,
            }
            const headers = {
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            // resetting password
            resetPassword(headers, requiredData).then(res => {
                // btn loading
                setButtonLoading(false)

                const resData = res.data

                if (resData?.success) {
                    formik.setFieldValue("password", "") // empty field value

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.success("Password updated successfully", {
                        autoClose: 2500,
                        onClose: () => { },
                    });
                }

                if (resData?.error) {
                    console.log("resData error ", resData);

                    // dismissing all the previous toasts first
                    toast.dismiss();

                    // showing the error message
                    toast.info(resData?.message ?? "Unknown error", {
                        autoClose: 2500,
                        onClose: () => {
                            // btn loading
                            setButtonDisable(false)
                        },
                    });
                }

            }).catch(err => {
                console.log("errr ", err);

                // btn loading
                setButtonDisable(false)
                setButtonLoading(false)
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        onSubmit: onFormSubmit,
        validationSchema: formValidationSchema
    })

    // toggle password
    const togglePasswordDisplay = ev => {
        ev.preventDefault()
        setShowPassword(!showPassword)
    }

    return (
        <div className="app-wrapper page-login">
            <div className="st-auth overflow-auto">
                <Container fluid className="h-100">
                    <div className="st-auth h-100 d-flex flex-column justify-content-center align-items-center">
                        <div className="inner border st-default-rounded-block bg-white">
                            {
                                isRequestValid ? (
                                    <React.Fragment>
                                        {/* top sec */}
                                        <div className="top-sec">
                                            <Link to="/" className="d-block mx-auto mb-3 mb-lg-4" style={{ width: 220 }} onClick={() => { return }}>
                                                <Image src={appLogo} fluid />
                                            </Link>
                                            <p className="head st-fs-24 st-fw-700 text-center">Reset password</p>
                                            <p className="mt-1 subhead text-center">Enter your new password</p>
                                        </div>

                                        {/* LOGIN FORM */}
                                        <div className="form-sec">
                                            <form
                                                onSubmit={formik.handleSubmit}
                                                noValidate
                                                autoComplete="off">
                                                {/* form field */}
                                                <div className={`st-form position-relative st-form-with-icon-right ${(formik.touched.password && formik.errors.password) && "has-msg msg-error"}`}>
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        className="form-control"
                                                        placeholder="Password"
                                                        id="password"
                                                        name="password"
                                                        {...formik.getFieldProps('password')}
                                                    />
                                                    <div
                                                        className="icon cursor-pointer"
                                                        style={{ top: 20, zIndex: 12, color: '#333' }}
                                                        onClick={togglePasswordDisplay}>
                                                        <FeatherIcon
                                                            icon={showPassword ? "eye" : "eye-off"}
                                                            size="17"
                                                            className="icon-main" />
                                                    </div>
                                                    {
                                                        /* form message */
                                                        (formik.touched.password && formik.errors.password) && (
                                                            <div className="st-form-msg">
                                                                <p className="st-fs-12">{formik.errors.password}</p>
                                                            </div>
                                                        )
                                                    }
                                                </div>

                                                {/* buttons */}
                                                <div className="btns d-flex align-items-center pt-1">
                                                    <Button
                                                        type="submit"
                                                        className="st-btn st-btn-primary st-fw-600 text-uppercase d-flex align-items-center justify-content-center w-100"
                                                        disabled={buttonDisable}>
                                                        {
                                                            buttonLoading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <span>Reset Password</span>
                                                            )
                                                        }
                                                    </Button>
                                                </div>
                                            </form>
                                        </div>
                                    </React.Fragment>
                                ) : (
                                    <React.Fragment>
                                        {
                                            !globalLoading ? (
                                                <div className="top-sec mt-3 mb-0">
                                                    <Link to="/" className="d-block mx-auto mb-3 mb-lg-4" style={{ width: 180 }} onClick={() => { return }}>
                                                        <Image src={appLogo} fluid />
                                                    </Link>
                                                    <p className="text-center st-fw-600 text-danger">Unauthorized access</p>
                                                </div>
                                            ) : null
                                        }
                                    </React.Fragment>
                                )
                            }
                        </div>

                        {/* other details */}
                        <div className="other-details text-center my-3">
                            <p className="text-decoration-none mb-1">
                                Cancel reset password and <Link to="/login" className="st-text-primary">take me to the login page.</Link>
                            </p>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
        globalLoading: state.common.globalLoading,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default WithLoginCheck(connect(getDataFromStore, dispatchActionsToProps)(ResetPassword))